/* eslint-disable react-hooks/exhaustive-deps */
import { CSSProperties, FC, useEffect, useState } from "react";
import { Alert } from '@mui/material';
import { Componente as ComponenteClass } from "src/components/componentes/Componente";
import api, { apiNoLoading } from "src/framework/providers/api";
import { Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRemove, faUpload } from "@fortawesome/free-solid-svg-icons";
import FileSaver from "file-saver";
import defaultListStore from "src/framework/store/DefaultListStore";
import theme from "src/theme/light";
import { LinearProgressBar } from "src/framework/components/commons/LinearProgressBar";
import { resolveProtocolUrl } from "src/store/global.store";
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { Upload } from "../../types";
import { InputDate } from "src/framework/components/forms/inputs/InputDate";

const DEFAULT_FILE_NAME_DATASHEET = "componente-datasheet";
const DEFAULT_FILE_NAME_PROCEL = "componente-procel";
const DEFAULT_FILE_NAME_FABRICANTE = "componente-fabricante";
const DEFAULT_FILE_NAME_INMETRO = "componente-inmetro";
const DEFAULT_FILE_NAME_MANUAL = "componente-manual";
const DEFAULT_FILE_NAME_ARQUIVO_SIMULACAO = "componente-arquivo-simulacao";


export const parseTipo = (tipo: string): string => {
  switch (tipo) {
    case "datasheet":
      return "Datasheet"
    case "procel":
      return "Selo Procel"
    case "fabricante":
      return "Declaração do fabricante"
    case "inmetro":
      return "Selo InMetro"
    case "manual":
      return "Manual de instalação"
    case "simulacao":
      return "Arquivo de simulação"
  }

  return ""
}

export const parseFileName = (tipo: string): string => {
  switch (tipo) {
    case "datasheet":
      return DEFAULT_FILE_NAME_DATASHEET
    case "procel":
      return DEFAULT_FILE_NAME_PROCEL
    case "fabricante":
      return DEFAULT_FILE_NAME_FABRICANTE
    case "inmetro":
      return DEFAULT_FILE_NAME_INMETRO
    case "manual":
      return DEFAULT_FILE_NAME_MANUAL
    case "simulacao":
      return DEFAULT_FILE_NAME_ARQUIVO_SIMULACAO
  }

  return ""
}

export interface IUploadData {
  url: string;
  tipo: "image" | "datasheet" | "procel" | "fabricante" | "inmetro" | "manual" | "simulacao"
}
export interface DocumentosProperties {
  datasheet?: Upload | null;
  imagem?: Upload | null;
  procel?: Upload | null;
  fabricante?: Upload | null;
  inMetro?: Upload | null;
  arquivoSimulacao?: Upload | null;
  manualInstalacao?: Upload | null;
  codigoComponente: number;
  onChangeDatasheet: (datasheetData: Upload) => void;
  onChangeProcel: (procelData: Upload) => void;
  onChangeFabricante: (fabricanteData: Upload) => void;
  onChangeInMetro: (fabricanteData: Upload) => void;
  onChangeManualInstalacao: (fabricanteData: Upload) => void;
  onChangeArquivoSimulacao: (arquvoSimulacaoData: Upload) => void;
  onLoading: (loadgin: boolean) => void;
}

export interface DocumentoRowPropeperties {
  codigoComponente?: string;
  upload: Upload | null | undefined;
  tipo: "datasheet" | "procel" | "fabricante" | "inmetro" | "manual" | "simulacao";
  style?: CSSProperties;
  onHandleUpload: (id: number, upload?: Upload | null) => void;
  onHandleRemove: (upload?: Upload | null) => void;
  onLoading: (loading: boolean) => void
}

export const downloadDocumento = (url: string, tipo: string, nomeArquivo: string): void => {
  if (url !== "") {

    const name: string[] = url.split(".");
    const extension: string | undefined = name.pop()?.replace(/\?r=\d{1,}/, "");
    if (extension) {
      FileSaver.saveAs(url, `${tipo}-${nomeArquivo}.${extension}`)
    }
  }
};

const DocumentoRow: FC<DocumentoRowPropeperties> = ({
  codigoComponente,
  upload,
  tipo,
  onHandleUpload,
  onHandleRemove,
  onLoading,
}) => {
  const Componente = new ComponenteClass(api, apiNoLoading)
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [uploadState, setUploadState] = useState<any>(null);
  const [validade, setValidade] = useState<any>(upload?.validade || null);
  const [remover, setRemover] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [progress, setProgress] = useState<number | undefined>(undefined);

  useEffect(() => {
    setUploadState(upload);
  }, [])

  useEffect(() => {
    setUploadState(upload);
  }, [upload])



  const parseSituacao = () => {

    if (remover) {
      return <span style={{ color: theme.palette.error.main }}>Remover</span>
    }

    if ((upload === null || upload === undefined) && selectedFile !== null) {
      return <span style={{ color: theme.palette.warning.main }}>Não salvo</span>
    }

    if (upload === null || upload === undefined) {
      return <span style={{ color: theme.palette.text.disabled }}>Sem arquivo</span>
    }

    if (upload && validade && upload.url !== "" && upload.validade !== validade) {
      return <span style={{ color: theme.palette.warning.main }}>Validade alterada</span>
    }

    if (upload && uploadState && selectedFile) {
      return <span style={{ color: theme.palette.warning.main }}>Documento alterado</span>
    }

    if (upload?.url !== "") {
      return <span style={{ color: theme.palette.primary.main }}>Ok</span>
    }

    return ""
  }

  const id = `select-${tipo}-${codigoComponente}`

  useEffect(() => {
    onLoading(loading)
  }, [loading]);


  useEffect(() => {
    if (selectedFile) {
      setRemover(false)
      setLoading(true)
      setProgress(undefined)
      Componente.uploadImage({
        codigoComponente: String(codigoComponente),
        file: selectedFile,
        fileName: parseFileName(tipo),
        tipo: tipo,
        onProgress: (_progress: number): void => {
          setProgress(_progress)
        }
      }).then((data) => {
        const _url = String(data?.url);
        const upload: Upload = uploadState ? { ...uploadState, url: _url } : {
          url: _url,
          tipo: tipo,
        }
        setUploadState(upload)
        if (onHandleUpload) {
          onHandleUpload(Number(codigoComponente), upload);
        }
      }).finally(() => {
        setLoading(false)
      })

    }
  }, [selectedFile]);

  useEffect(() => {
    if (validade) {
      setRemover(false)
      let _upload: any = uploadState;
      if (_upload) {
        _upload.validade = validade;
        onHandleUpload(Number(codigoComponente), _upload);
      }
    }
  }, [validade]);


  return <>

    <TableRow>
      <TableCell>
        <Button variant="text" color="secondary" component="span"
          disabled={uploadState === null || uploadState === undefined}
          onClick={() => {
            downloadDocumento(resolveProtocolUrl(`//${defaultListStore.uploadUrl}${uploadState?.url}`), tipo, String(codigoComponente));
          }}
        >{parseTipo(tipo)}
        </Button>
      </TableCell>
      <TableCell width={200}>{loading ? <><LinearProgressBar progress={Number(progress)} /></> : parseSituacao()}</TableCell>
      <TableCell>
        <InputDate margin="dense" label="" fullWidth type="date" value={validade}
          disabled={uploadState === null || uploadState === undefined}
          onChange={(value: any) => {
            if (value !== "") {
              setValidade(value)
            }
          }}
        />
      </TableCell>
      <TableCell align="right">
        <input
          accept="*"
          type="file"
          id={id}
          style={{ display: 'none' }}
          disabled={loading}
          onChange={(e) => {
            if (e.target.files !== null) {
              setSelectedFile(e.target?.files[0])
            }
          }}
        />
        <label htmlFor={id}>
          <Button size="small" variant="text" color="secondary" component="span" disabled={loading}>
            <FontAwesomeIcon icon={faUpload} size="sm" />
          </Button>
        </label>
        <IconButton size="small" disabled={uploadState === null || uploadState === undefined}
          onClick={() => {
            if (upload?.created_at) {
              confirmationDialog.setup({
                title: "Aviso!!!",
                content: `Deseja remover o documento "${parseTipo(tipo)}"?`,
                onClose: () => {
                  confirmationDialog.close();
                },
                onConfirmation: () => {
                  setSelectedFile(null);
                  setRemover(true);
                  onHandleRemove({ ...uploadState, "@remove": true })
                  confirmationDialog.close();
                }
              })
              confirmationDialog.open()
            }
          }}
        >
          <FontAwesomeIcon icon={faRemove} size="sm" style={{ color: uploadState === null || uploadState === undefined ? theme.palette.text.disabled : theme.palette.error.main }} />
        </IconButton>
      </TableCell>
    </TableRow>
  </>
}

const Documentos: FC<DocumentosProperties> = ({
  datasheet,
  procel,
  fabricante,
  inMetro,
  manualInstalacao,
  arquivoSimulacao,
  codigoComponente,
  onChangeDatasheet = () => { },
  onChangeProcel = () => { },
  onChangeFabricante = () => { },
  onChangeInMetro = () => { },
  onChangeManualInstalacao = () => { },
  onChangeArquivoSimulacao = () => { },
  onLoading,
}) => {

  const [condigoComponenteState, setCondigoComponenteState] = useState<number>(codigoComponente);

  useEffect(() => {
    setCondigoComponenteState(condigoComponenteState)
  }, [condigoComponenteState])

  const prop: any = {
    onLoading: (loading: boolean): void => {
      onLoading(loading)
    }
  }

  return (
    <div className="row">
      {codigoComponente === 0 ?
        (<div
          className="X12"
          style={{
            display: codigoComponente === 0 ? "inherit" : "none",
            textAlign: "center",
          }}
        >
          <Alert
            severity="warning"
            style={{ alignSelf: "center", margin: "10px auto" }}
          >
            Componente ainda não foi definido!
          </Alert>
        </div>)
        :
        (<div className="X12">
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Tipo</TableCell>
                  <TableCell>Situação</TableCell>
                  <TableCell>Data de validade</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>

                <DocumentoRow codigoComponente={String(codigoComponente)} tipo="datasheet" upload={datasheet}
                  {...prop}
                  key={`componente-datasheet-${codigoComponente}`}
                  onHandleUpload={(id, _upload) => {
                    if (_upload) {
                      onChangeDatasheet(_upload);
                    }
                  }}
                  onHandleRemove={(_upload) => {
                    if (_upload) {
                      onChangeDatasheet(_upload);
                    }
                  }}

                />
                <DocumentoRow codigoComponente={String(codigoComponente)} tipo="procel" upload={procel}
                  {...prop}
                  key={`componente-procel-${codigoComponente}`}
                  onHandleUpload={(id, _upload) => {
                    if (_upload) {
                      onChangeProcel(_upload);
                    }
                  }}
                  onHandleRemove={(_upload) => {
                    if (_upload) {
                      onChangeProcel(_upload);
                    }
                  }}
                />
                <DocumentoRow codigoComponente={String(codigoComponente)} tipo="fabricante" upload={fabricante}
                  {...prop}
                  key={`componente-fabricante-${codigoComponente}`}
                  onHandleUpload={(id, _upload) => {
                    if (_upload) {
                      onChangeFabricante(_upload);
                    }
                  }}
                  onHandleRemove={(_upload) => {
                    if (_upload) {
                      onChangeFabricante(_upload);
                    }
                  }}
                />
                <DocumentoRow codigoComponente={String(codigoComponente)} tipo="inmetro" upload={inMetro}
                  {...prop}
                  key={`componente-inmetro-${codigoComponente}`}
                  onHandleUpload={(id, _upload) => {
                    if (_upload) {
                      onChangeInMetro(_upload);
                    }
                  }}
                  onHandleRemove={(_upload) => {
                    if (_upload) {
                      onChangeInMetro(_upload);
                    }
                  }}
                />
                <DocumentoRow codigoComponente={String(codigoComponente)} tipo="manual" upload={manualInstalacao}
                  {...prop}
                  key={`componente-manual-instalacao-${codigoComponente}`}
                  onHandleUpload={(id, _upload) => {
                    if (_upload) {
                      onChangeManualInstalacao(_upload);
                    }
                  }}
                  onHandleRemove={(_upload) => {
                    if (_upload) {
                      onChangeManualInstalacao(_upload);
                    }
                  }}
                />
                <DocumentoRow codigoComponente={String(codigoComponente)} tipo="simulacao" upload={arquivoSimulacao}
                  {...prop}
                  key={`componente-arquivo-simulacao-${codigoComponente}`}
                  onHandleUpload={(id, _upload) => {
                    if (_upload) {
                      onChangeArquivoSimulacao(_upload);
                    }
                  }}
                  onHandleRemove={(_upload) => {
                    if (_upload) {
                      onChangeArquivoSimulacao(_upload);
                    }
                  }}
                />
              </TableBody>
            </Table>
          </TableContainer>
        </div>)
      }




    </div>
  );
};

export { Documentos };
